export class Globals {
  
  public static webSiteUrl = "https://site.wheelofharmonies.de";
  public static webJens = "https://e-gitarrenunterricht-leipzig.de";
  public static webJan = "https://www.youtube.com/@schludnik";
  public static webPlayStore = "https://play.google.com/store/apps/details?id=com.janbrinkel.coh.app";

  private static _baseWebUrl = "https://wheelofharmonies.de";
  public static set baseWebUrl(url: string) { Globals._baseWebUrl = url; }
  public static get baseWebUrl(): string { return Globals._baseWebUrl; }

  public static baseAPIUrl = "https://wheelofharmonies.de/api/index.php";
  public setBaseAPIUrl(url: string) { Globals.baseAPIUrl = url; }

  public static wohVersion: number = 123; 
}